import { render, staticRenderFns } from "./DevTools.vue?vue&type=template&id=6604e1cb&"
import script from "./DevTools.vue?vue&type=script&lang=js&"
export * from "./DevTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports